import moment from 'moment';
import { DateRange } from '../../models/date-range.interface';

export class DateHelper {
  public static getDateRange(dateRange: DateRange, format = 'MMM yyyy'): string {
    if (dateRange?.from && dateRange?.to) {
      return moment(dateRange?.from).format(format) + ' - ' + moment(dateRange?.to).format(format);
    }
  }
}
